import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Alert, Button, Form, Input, Modal } from 'antd';
import { changePassword } from '../../store/actions/authActionCreators';
interface IProps {
  showAskPasswordChangeModal: boolean;
  cancelAskPasswordChangeHandler: () => void;
  // changeLocalStorage: () => void;
  token: any;
}

const AskPasswordChangeModal = (props: IProps) => {
  const [askPasswordChangeForm] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [serverError, setServerError] = useState<string | null>(null);
  const [serverSuccess, setServerSuccess] = useState<string | null>(null);

  const history = useHistory();

  const handleClose = () => {
    props.cancelAskPasswordChangeHandler();
    history.push('/login');
  };

  const changePasswordHandler = async (values: any) => {
    setServerError(null);
    setServerSuccess(null);
    setLoading(true);
    const data = {
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword
    };
    const [response, err]: Array<any> = await changePassword(data, props.token);
    if (response) {
      if (!response.data.succeeded) {
        setServerError(response.data.errors[0]);
        setLoading(false);
        return;
      }
      setServerSuccess('Password updated Successfully.Redirecting to login page');

      // props.changeLocalStorage();
      // debugger;
      // props.cancelAskPasswordChangeHandler();

      // history.push('/login');

      window.setTimeout(() => {
        setLoading(false);
        handleClose();
        history.push('/login');
      }, 3000);
    }
    if (err) {
      if (err.response.data.succeeded) {
        setServerError(err.response.data.data.errors[0]);
      } else {
        setServerError(err.response.data.message);
      }
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Change Password"
      centered
      width={1000}
      visible={props.showAskPasswordChangeModal}
      footer={[
        <Button onClick={handleClose}>Close</Button>,
        <Button loading={loading} form="askPasswordChangeForm" type="primary" key="submit" htmlType="submit">
          Change Password
        </Button>
      ]}
    >
      <div className="form__wrapper">
        <div className="alert__wrapper" style={{ marginBottom: '10px' }}>
          {serverError && <Alert message={serverError} type="error" closable showIcon />}
          {serverSuccess && <Alert message={serverSuccess} type="success" closable showIcon />}
        </div>
        <Form
          form={askPasswordChangeForm}
          layout="vertical"
          id="askPasswordChangeForm"
          name="Chanage Password"
          onFinish={changePasswordHandler}
          scrollToFirstError
        >
          <Form.Item name="currentPassword" rules={[{ required: true, message: 'current password is required' }]}>
            <Input.Password placeholder="Please enter your temporary password" />
          </Form.Item>
          <Form.Item name="newPassword" rules={[{ required: true, message: 'New password is required' }]}>
            <Input.Password placeholder="Please enter your New password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            rules={[
              { required: true, message: 'Confirm password is required' },
              ({ getFieldValue }) => ({
                validator(rules, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Password does not match!');
                }
              })
            ]}
          >
            <Input.Password placeholder="Please enter your Conform password" />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AskPasswordChangeModal;
